<div id="ceviri">
  <h1 class="kirmizi">Çeviri ekle</h1>
  <form method="POST" action="/ceviri/ekle">
    <label for="çeviridili">Dil</label>
    <select id="çeviridili" name="çeviridili">
      <option value="tr">Türkçe</option>
      <option value="de">Almanca</option>
      <option value="ar">Arapça</option>
      <option value="az">Azeri</option>
      <option value="en">İngilizce</option>
    </select>
    <br>
    <br>
    <label for="çeviri">Cümle</label>
    <br>
    <textarea cols="70" id="çeviri" name="çeviri" rows="5">
    </textarea>
    <br>
    <br>
    <input type="text" id="cümleno" name="cümleno" value="107">
    <input type="submit" value="Gönder">
  </form>
</div>
